export default "__VITE_ASSET__B3YKJU2U__"